import { createSelector } from 'reselect'
import { selectChannelCustomFieldCategoryGroups } from './selectChannelCustomFieldCategoryGroups'

export const selectChannelCustomFieldsGroupsByKey = createSelector(
  selectChannelCustomFieldCategoryGroups,
  groups => {
    return groups.reduce((result, group) => {
      // eslint-disable-next-line no-param-reassign
      result[group.key] = group.fields
      return result
    }, {})
  }
)
